import styled from 'styled-components';
import BathroomIconSvg from '../../assets/hotels/amenities/Bathroom.svg';

const BathroomIcon = styled(BathroomIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default BathroomIcon;
